import { Grid } from "@mui/material";
import { FC, useState, useEffect } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import { useNavigate } from "react-router-dom";
import { H4} from "../../components/Typography";
import { load, remove } from "../../constants/storage";
import * as Models from "../../models";
import { useAppDispatch } from "../../store/hooks";
import { toast } from "react-hot-toast";
import { checkSIPMandate } from "../../redux/actions/PortfolioAction";

const MFMandateStatus: FC = () => {
  const [loading, setLoading] = useState(true);
  let navigate = useNavigate();
  const dispatch = useAppDispatch();

  useEffect(() => {
    checkToken();
  }, []);

  const checkToken = async () => {
    let token = await load("token");
    if (token === undefined) {
      remove("userData");
      remove("token");
      toast.success("Session expired, please login again.");
      navigate("/login");
    } else {
      setTimeout(() => {
        const url = new URL(window.location.href);
        const orderid: any = url.searchParams.get("id");
        createSIP(orderid);
      }, 5000);
    }
  };

  const createSIP = async (orderid: any) => {
    const data: Models.checkSipStatus = {
      id: orderid,
    };
    setLoading(true);
    let token = await load("token");

    dispatch(checkSIPMandate(data, `${token}`))
      .then(async (response: any) => {
        setLoading(false);
        window.open(response.data.token_url, "_self");
      })
      .catch((error: any) => {
        setLoading(false);
        toast.error(
          "Got error while getting a fund details, please try after sometimes!"
        );
      });
  };

  return (
    <Grid
      height="100vh"
      display="flex"
      flexDirection="column"
      sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
    >
      <CircularProgress />
      <H4 sx={{ mt: 2 }}>We are processing your payment</H4>
      <H4>Please wait</H4>
    </Grid>
  );
};

export default MFMandateStatus;
